<div class="table-content-component-panel-monitoreo" style="position: relative;">

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingPlatformAlertsSpinner" size="medium" color="#fff"
    type="ball-pulse" [fullScreen]="false">
    <p style="color: white"> Cargando Alertas Plataforma... </p>
  </ngx-spinner>

  <div class="panel-izq-table-container">
    <p-table
      #dt
      [value]="alerts"
      [scrollable]="true"
      scrollHeight="74vh"
      styleClass="p-datatable-sm"
      [globalFilterFields]="['nombre']"
    >

      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between align-items-center px-2 gap-2 py-2">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              type="text"
              pInputText
              placeholder="Filtrar por nombre o tipo..."
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              class="w-100"
            />
          </span>
          <div class="d-flex flex-row gap-1">
            <button *appHasPermission="'alerts_new_create'" type="button"
              class="btn-gl-blue btn-dark-hover btn-circle flex-none me-2" (click)="clickShowPanel('ALERTS-PLATFORM-CREATE')">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>

            <div ngbDropdown container="body" placement="right-top left-top" class="flex-none">
              <button class="btn-gl-gray-blue btn-dark-hover btn-circle" ngbDropdownToggle>
                <i class="fa fa-fw fa-bars fa-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu class="gl-custom-dropdown dropdown-alert-panel">
                <div ngbDropdownItem (click)="panelService.clickHeaderToggle('ALERTS')">
                  <span>{{'ALERTS.OPTIONS.ALL' | translate}}</span>
                </div>

                <div *ngIf="checkAlertCategory('gps')" ngbDropdownItem (click)="panelService.clickHeaderToggle('ALERTS-GPS')">
                  <span>{{'ALERTS.OPTIONS.GPS_TRACKER' | translate}}</span>
                </div>
                <div *ngIf="checkAlertCategory('platform')" ngbDropdownItem
                  (click)="panelService.clickHeaderToggle('ALERTS-PLATFORMS')">
                  <span>{{'ALERTS.OPTIONS.PLATFORM' | translate}}</span>
                </div>
                <div *ngIf="checkAlertCategory('security')" ngbDropdownItem
                  (click)="panelService.clickHeaderToggle('ALERTS-SECURITY')">
                  <span>{{'ALERTS.OPTIONS.VEHICLE_SECURITY' | translate}}</span>
                </div>
                <div *ngIf="checkAlertCategory('mobile')" ngbDropdownItem
                  (click)="panelService.clickHeaderToggle('ALERTS-MOBILE')">
                  <span>{{'ALERTS.OPTIONS.MOBILE_SOLUTIONS' | translate}}</span>
                </div>
                <div *ngIf="checkAlertCategory('360')" ngbDropdownItem (click)="panelService.clickHeaderToggle('ALERTS-360')">
                  <span>{{'ALERTS.OPTIONS.FATIGUE_360' | translate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 30%;" class="text-start">{{ 'ALERTS.LABEL.NAME' | translate }}</th>
      <th style="width: 20%;" class="text-center">Unidades</th>
      <th style="width: 15%;" class="text-center">{{ 'ALERTS.LABEL.ACTIVE' | translate }}</th>
      <th style="width: 15%;" class="text-center">{{ 'ALERTS.LABEL.SYSTEM' | translate }}</th>
      <th style="width: 10%;" class="text-center">
        <i class="fa fas fa-at fa-lg"></i>
      </th>
      <th style="width: 10%;" class="text-center">
        <i class="fa fa-pencil fa-lg"></i>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-alert>
    <tr>
      <td style="width: 30%;" class="text-start">{{ alert.nombre }}</td>
      <td style="width: 20%;" class="text-center">{{ alert.imeiCount }}</td>
      <td style="width: 15%;" class="text-center">
        <div class="text-center">
          <app-active-alert [alert]="alert"></app-active-alert>
        </div>
      </td>
      <td style="width: 15%;" class="text-center">
        <div class="text-center">
          <app-system-alert [alert]="alert"></app-system-alert>
        </div>
      </td>
      <td style="width: 10%;" class="text-center">
        <div class="text-center">
          <app-email-alert [alert]="alert"></app-email-alert>
        </div>
      </td>
      <td style="width: 10%;" class="text-center">
        <app-actions-alert
          [alert]="alert"
          [nameComponent]="'ALERTS-PLATFORMS'"
          (editAlert)="edit($event)"
          (deleteAlert)="loadData()"
        ></app-actions-alert>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="text-center">
        {{ noResults ? ('ALERTS.MESSAGE.NO_MATCH' | translate) : ('ALERTS.MESSAGE.NO_ALERTS_CONFIGURED' | translate) }}
      </td>
    </tr>
  </ng-template>
</p-table>

  </div>

</div>


<!-- </div> -->